import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-entities-widgets-listing',
  templateUrl: './entities-widgets-listing.component.html',
  styleUrls: ['./entities-widgets-listing.component.css']
})
export class EntitiesWidgetsListingComponent implements OnInit {
  @Input() entityId: any;
  @Input() masterEntitiesData: any;
  @Input() attributeThreshold: any;
  @Input() widgetDetails: any;
  @Input() siteId: string;
  @Input() loader: boolean;
  @Input() fromDate: string;
  @Input() toDate : string;
  constructor() { }

  ngOnInit(): void {
  }

}
